// extracted by mini-css-extract-plugin
module.exports = {"siderSection":"style_siderSection__2_VjV","siderLeft":"style_siderLeft__9JpPQ","tabs":"style_tabs__10s9P","active":"style_active__2DKyV","siderRight":"style_siderRight__19bfU"};